const state = () => ({
  clientId: '',
  clientTypeId: 0,
  firstName: '',
  lastName: '',
  email: '',
  telephoneMobile: '',
  startUtc: '',
  duration: 120,
  defaultDuration: 120,
  resourceIds: [],
  selectedPets: [],
  clientAddress: {
    line1: '',
    line2: '',
    line3: '',
    town: '',
    county: '',
    postCode: ''
  },
  participants: [],
  stackGroupBooking: false,
  extendBeyondSlotDuration: false,
  openSlotBooking: false,
  openSlotDuration: 0
})

const getters = {
  bookingUploadModel: (state) => {
    return {
      clientId: state.clientId,
      clientTypeId: state.clientTypeId,
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      telephoneMobile: state.telephoneMobile,
      startUtc: state.startUtc,
      duration: state.duration,
      resourceIds: state.resourceIds,
      selectedPets: state.selectedPets,
      clientAddress: state.clientAddress,
      stackGroupBooking: state.stackGroupBooking
    }
  }
}

const mutations = {
  setSelectedPets (state, pets) {
    state.selectedPets = pets
  },
  clearSelectedPets (state) {
    state.selectedPets = []
  },
  setResourceIds (state, resourceIds) {
    state.resourceIds = resourceIds
  },
  setStartUtc (state, startUtc) {
    state.startUtc = startUtc
  },
  clearStartUtc (state) {
    state.startUtc = ''
  },
  setDuration (state, duration) {
    state.duration = duration
  },
  setDefaultDuration (state, duration) {
    state.defaultDuration = duration
  },
  setStackGroupBooking (state, stackGroupBooking) {
    state.stackGroupBooking = stackGroupBooking
  },
  setExtendBeyondSlotDuration (state, value) {
    state.extendBeyondSlotDuration = value
  },
  setOpenSlotBooking (state, value) {
    state.openSlotBooking = value
  },
  setOpenSlotDuration (state, value) {
    state.openSlotDuration = value
  },
  setFirstName (state, firstName) {
    state.firstName = firstName
  },
  setClientId (state, clientId) {
    state.clientId = clientId
  },
  setClientTypeId (state, clientTypeId) {
    state.clientTypeId = clientTypeId
  },
  setLastName (state, lastName) {
    state.lastName = lastName
  },
  setEmail (state, email) {
    state.email = email
  },
  setTelephoneMobile (state, telephoneMobile) {
    state.telephoneMobile = telephoneMobile
  },
  removePet (state, id) {
    state.selectedPets.forEach((pet) => {
      pet.isValid = false
    })
    state.selectedPets = state.selectedPets.filter(p => p.id !== id)
  },
  addPet (state) {
    let newId
    do {
      newId = Math.random().toString(36).substring(7)
    } while (state.selectedPets.some(p => p.id === newId))
    state.selectedPets.push({
      id: newId,
      petId: '',
      appointmentDuration: 0,
      name: '',
      breedId: '',
      serviceItems: [],
      isValid: false,
      openSlotId: ''
    })
  },
  setOpenSlotId (state, { petId, openSlotId }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.openSlotId = openSlotId
    }
  },
  updateBreed (state, { petId, breedId }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.breedId = breedId
    }
  },
  updatePetName (state, { petId, name }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.name = name
    }
  },
  addServiceItem (state, { petId, serviceItem }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.serviceItems.push(serviceItem)
    }
  },
  removeServiceItem (state, { petId, serviceItem }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.serviceItems = existing.serviceItems.filter(si => si.id !== serviceItem.id)
    }
  },
  updatePetAppointmentDuration (state, { petId, duration }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.appointmentDuration = duration
    }
  },
  clearServiceItems (state, petId) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.serviceItems = []
    }
  },
  updatePetIsValid (state, { petId, value }) {
    const existing = state.selectedPets.find(p => p.id === petId)
    if (existing) {
      existing.isValid = value
    }
  },
  setClientAddress (state, address) {
    state.clientAddress = {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postCode: '',
      ...address
    }
  },
  setParticipants (state, participants) {
    state.participants = participants
  },
  resetBookingUpload (state) {
    state.clientId = ''
    state.clientTypeId = 0
    state.firstName = ''
    state.lastName = ''
    state.email = ''
    state.telephoneMobile = ''
    state.startUtc = ''
    state.duration = 120
    state.defaultDuration = 120
    state.resourceIds = []
    state.selectedPets = []
    state.clientAddress = {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postCode: ''
    }
    state.participants = []
    state.stackGroupBooking = false
    state.extendBeyondSlotDuration = false
    state.openSlotBooking = false
    state.openSlotDuration = 0
  },
  updateBookingUploadState (state, booking) {
    state.clientId = booking.clientId
    state.clientTypeId = booking.clientType.id
    state.firstName = booking.firstName
    state.lastName = booking.lastName
    state.email = booking.email
    state.telephoneMobile = booking.telephoneMobile
    state.startUtc = booking.startUtc
    state.duration = booking.duration
    state.defaultDuration = booking.duration
    state.resourceIds = booking.participants.map(participant => participant.resourceId)
    state.selectedPets = booking.participants.map(participant => {
      return {
        id: participant.id,
        petId: participant.petId,
        appointmentDuration: participant.appointmentDuration || 0,
        name: participant.name,
        breedId: participant.breedId,
        serviceItems: participant.serviceItems.map(item => {
          return {
            id: item.productId,
            quantity: item.quantity,
            amount: item.amount,
            name: item.name,
            description: item.description
          }
        }),
        isValid: true
      }
    })
    state.clientAddress = {
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postCode: ''
    }
    state.participants = booking.participants
    state.stackGroupBooking = booking.stackGroupBooking || false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
